/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_BInputs */

const cs_enum_b = /** @type {(inputs: Enum_BInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`B`)
};

const en_enum_b = /** @type {(inputs: Enum_BInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`B`)
};

/**
* | output |
* | --- |
* | "B" |
*
* @param {Enum_BInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_b = /** @type {((inputs?: Enum_BInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_BInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_b(inputs)
	return cs_enum_b(inputs)
});